import request from '../utils/csrf-superagent';
import config from '../config';
import actions from '../actions/actions';
import payoutDetailsActions from '../actions/payoutDetails';

function getBankingCountries(store) {
    request.get(`/${config.url_prefix}/api/getBankingCountries`)
        .end((error, response) => {
            if (error) {
                store.dispatch(payoutDetailsActions.alertError('ipmob.internal.server.error'));
            } else {
                try {
                    const res = JSON.parse(response.text);
                    store.dispatch(payoutDetailsActions.getBankingCountriesSuccess(res));
                } catch (exp) {
                    store.dispatch(payoutDetailsActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getBankingCountries;
